import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import type { Group } from "three";
import * as THREE from "three";
import { RocketFlame } from "./RocketFlame";
import { useGLTF } from "@react-three/drei";

// Preload the model
useGLTF.preload("/models/rocket.glb");

export function Rocket3D({ rotation = 0 }: { rotation: number }) {
  const groupRef = useRef<Group>(null);
  const { scene } = useGLTF("/models/rocket.glb");

  useFrame((state) => {
    if (groupRef.current) {
      // Smoothly interpolate rotation for fluid movement
      // We rotate around Z for 2D tilt.
      // Note: Chart Y is inverted (down is positive), so we might need to invert angle sign.
      groupRef.current.rotation.z = THREE.MathUtils.lerp(
        groupRef.current.rotation.z,
        rotation,
        0.1,
      );

      // Y rotation: oscillate between 20 and -20 degrees every 1s (half-period)
      const time = state.clock.elapsedTime;
      // Full cycle (20 -> -20 -> 20) takes 2 seconds -> frequency = PI
      const speed = Math.PI;
      const amplitude = THREE.MathUtils.degToRad(20);

      groupRef.current.rotation.x = Math.cos(time * speed) * amplitude;
    }
  });

  return (
    <group ref={groupRef} scale={21} dispose={null}>
      {/* 3D Model */}
      {/* Adjust rotation to point right (standard for our setup)
                Default model likely points UP or FRONT.
                Based on previous code, we rotated cylinders -Math.PI/2.
                Let's assume model needs similar adjustment.
                Scale: 0.5 to keep it reasonable size.
            */}
      <primitive
        object={scene.clone()}
        scale={1}
        rotation={[5, 0, -Math.PI / 2]}
        position={[-0.5, 0.15, 0]} // Center visual offset if needed
      />

      <RocketFlame />
    </group>
  );
}
